<template>
<transition name="fade">
  <div class="return-top" @click="route" v-if="scrollY > 0">
    <i class="iconfont icon-down"></i>
  </div>
</transition>
</template>

<script>
import scroller from 'vue-scrollto'

export default {
  name: 'return-top',
  data () {
    return {
      scrollY: 0
    }
  },
  created () {
  },
  mounted () {
    this.listenerScroll()
    window.addEventListener('scroll', this.listenerScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenerScroll)
  },
  methods: {
    /**
     * 监听 scroll
     * top 不为 0 时显示
     */
    listenerScroll (event) {
      this.scrollY = window.pageYOffset
    },
    /**
     * 跳转
     */
    route () {
      scroller.scrollTo('#app')
    }
  }
}
</script>
<style scoped lang="scss">
.return-top {
  position: fixed; right: 50px; bottom: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px; height: 60px;
  background: #CCC;
  border-radius: 60px;
  opacity: 0.3;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  & .iconfont {
    font-size: 26px; font-weight: bold;
    transform: rotate(180deg) translateY(-2px);
    color: #FFF;
  }
}
</style>
